import m from "../../es2015/lang/sk_SK";
window.am4lang_sk_SK = m;


//////////////////
// WEBPACK FOOTER
// ./lang/sk_SK.js
// module id = null
// module chunks = 